import { mapGetters } from 'vuex';
import profileService from '@/services/profile';
import Utils from "@/mixins/Utils";

export default {
  name: 'ScheduleWishesForm',
  components: {},
  data: () => ({
    error: false,
    pkAdv: 20190712000028,
    days: [],
  }),
  mixins: [Utils],
  computed: {
    ...mapGetters({
      loading: 'isLoading',
    })
  },

  created() {
    this.chargePlanning();
  },
  methods: {
    chargePlanning() {
      const vue = this;
      profileService.getChargePlanning().then(res => {
        if (res.success) {
          vue.days = res.data.listAvailability
          return;
        }
        vue.error = true;
      }).catch(err => {
        vue.error = true;
      })
    },
    submitPlanning() {
      const vue = this;
      const data = {
        pkAdv: vue.pkAdv,
        days: vue.days,
      };
      profileService.submitPlanning(data).then(res => {
        if (res.success) {
          vue.callToaster(vue.$t('modification-saved'));
          return;
        }
        vue.callToaster(res.message);
      }).catch(err => {
        vue.output = err;
      })
    },
    on24HChecked(name) {
      const findDay = (dayName) => this.days.find((day) => day.name === dayName);
      if (findDay(name).morning && findDay(name).afternoon && findDay(name).evening) {
        this.onChangeDay(findDay(name), false);
      } else {
        this.onChangeDay(findDay(name), true);
      }
    },
    onChangeDay(day, val) {
      day.morning = val;
      day.afternoon = val;
      day.evening = val;
    }
  },
};